import React from 'react' 
import { Container,Col,Row,Button, Form, ResponsiveEmbed } from 'react-bootstrap'
import { Link, Redirect } from 'react-router-dom'
import  Card from '../../../components/Card'
import {connect} from "react-redux";
import {getDarkMode} from '../../../store/mode'
import { useHistory } from 'react-router-dom'
//img
import logo from '../../../assets/images/logo.png'
import darklogo from '../../../assets/images/logo-dark.png'
import bg from '../../../assets/images/login.jpg'
import robo from '../../../assets/images/Robo.png'
import ablogo from '../../../assets/images/AB_logo.png'

import { useState } from 'react';
import ReactLoading from "react-loading";
import { loginUser, getAppConfig } from '../../../service/auth-service';
import { useDispatch } from 'react-redux';
import { setLogin, setUserToken } from '../../../constants/localStorageFunctions';
import { setLoginState, setLoginUser } from './state/auth-slice';
import { warningToast } from '../../../constants/Toasts-Components';




function mapStateToProps(state) {
   return {
       darkMode: getDarkMode(state)
   };
}



const SignIn = (props) => {
   const dispatch = useDispatch();
    let history =useHistory()

    const [email,setEmail] = useState("")
    const [loading,setLoading] = useState(false)
    const [password,setPassword] = useState("")
    const [error,setError] = useState("")
    

    const handleSubmit = async (event) => {
      
      event.preventDefault();
      setLoading(true);
      setError(""); // Clear previous errors
      
      var response = await loginUser({email:email,password:password});
      console.log("Login response:", response);

      if(response.status != 200){
         console.log("Login error:", response);
         
         // Handle different error scenarios
         if(response.response && response.response.data){
            // Extract error message from response
            const errorData = response.response.data;
            let errorMessage = "Errore di accesso";
            
            if(typeof errorData === 'string'){
               errorMessage = errorData;
            } else if(errorData.message){
               errorMessage = errorData.message;
            } else if(errorData.error){
               errorMessage = errorData.error;
            } else if(errorData.non_field_errors){
               errorMessage = errorData.non_field_errors[0] || "Credenziali non valide";
            } else if(errorData.detail){
               errorMessage = errorData.detail;
            } else {
               errorMessage = "Credenziali non valide. Controlla email e password.";
            }
            
            setError(errorMessage);
            warningToast(errorMessage);
         } else if(response.message){
            setError(response.message);
            warningToast(response.message);
         } else {
            const defaultError = "Errore di connessione. Riprova più tardi.";
            setError(defaultError);
            warningToast(defaultError);
         }

      }else{

         console.log("Getting app config");
         setUserToken(response.data.token);

         response = await getAppConfig();
         console.log("config response:", response);

         if(response.response){
            console.log("Could not get app-config");
            const configError = "Errore durante il caricamento della configurazione";
            setError(configError);
            warningToast(configError);

         }else{
            setLogin(response.data);
            dispatch(setLoginState(true));
            dispatch(setLoginUser(response.data));
            
            // Use window.location for a hard redirect to ensure proper state refresh
            // window.location.href = "/";
         }
      }
      
      setLoading(false);
   }


   // if(props.login){
   //   return <Redirect to="/" />;
   // }
    return  (
        <>
      <section className="login-content overflow-hidden" style={{ backgroundImage: `linear-gradient(rgba(205, 54, 147, 0.2), rgba(205, 54, 147, 0.2)), url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
         {/* AB Logo - Top Left */}
         <div style={{ position: 'absolute', top: '50px', left: '70px', zIndex: 10 }}>
            <img src={ablogo} alt="AB Logo" style={{ width: '200px', height: 'auto' }} />
         </div>
         
         {/* Robo Image - Bottom Left */}
         <div style={{ position: 'absolute', bottom: '-20px', left: '-20px', zIndex: 10 }}>
            <div className='d-flex flex-col align-items-end'>

               <img src={robo} alt="Robo" style={{ width: '350px', height: 'auto' }} />
               <div className='mb-4'>
                  <p className='d-flex text-white fw-bolder p-1 px-3' style={{backgroundColor: 'rgba(205, 54, 147, 1)', borderRadius: '10px', fontWeight: 'bold', fontSize: '1.2rem', width: 'fit-content'}}>Aria 1.0!</p>
                  <p className='d-flex text-white fw-bolder p-1 px-3' style={{backgroundColor: 'rgba(205, 54, 147, 1)', borderRadius: '10px', fontWeight: 'bold', fontSize: '1.2rem', width: 'fit-content'}}>Finanza agevolata integrata con intelligenza artificiale</p>
               </div>
            </div>

         </div>
         
         <Container className="h-100" st>
            <Row className="align-items-center justify-content-center h-100">
               <Col md="6">
                  <Card className="p-3" style={{ background: 'rgba(205, 54, 147, 0.5)', zIndex: 10 }}>
                     <Card.Body >
                        
                        <p className="text-white mb-4" style={{fontWeight: 'normal', fontSize: '2rem'}}>Benvenuto su tuo spazio intelligente per finanziare tutti i tuoi clienti tramite Aria.</p>
                        
                        {/* Error Message Display */}
                        {error && (
                           <div className="alert alert-danger" role="alert" style={{ borderRadius: '10px', backgroundColor: 'rgba(220, 53, 69, 0.9)', color: 'white', fontWeight: 'bold' }}>
                              {error}
                           </div>
                        )}
                       
                        <Form onSubmit={handleSubmit}>
                           <Row>
                              <Col lg="12">
                                 <Form.Group>
                                    <Form.Label className="text-secondary">E-mail</Form.Label>
                                    <Form.Control style={{ background: 'rgba(54, 6, 35, 0.5)', borderRadius: '15px', fontSize: '2rem' }} className='border-dark text-secondary p-5' type="email" placeholder="Il tuo E-mail" value={email} onChange={(e)=>setEmail(e.target.value)} required/>
                                 </Form.Group>
                              </Col>
                              <Col lg="12" className="mt-2">
                                 <Form.Group>
                                    <Form.Label className="text-secondary">Password</Form.Label>
                                    <Form.Control style={{ background: 'rgba(54, 6, 35, 0.5)', borderRadius: '15px', fontSize: '2rem' }} className='border-dark text-secondary p-5' type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Il tuo Password" required/>
                                     <div className="d-flex justify-content-end align-items-center">
                                         <Form.Label><Link to="/auth/recoverpw" className='text-primary fw-bold'>Ha dimenticato la password?</Link></Form.Label>
                                     </div>
                                 </Form.Group>
                              </Col>
                           </Row>
                            
                           {loading?
                           <Button type="button" disabled  variant="btn btn-primary btn-block mt-2">                           
                           <ReactLoading
                           className="mx-auto"
                              type={"spin"}
                              color={"#fefefe"}
                              height={30}
                              width={30}
                           />
                           </Button>

                           :<Button type="submit" style={{ background: 'rgba(54, 6, 35, 0.8)', borderColor: 'rgba(54, 6, 35, 1)'}}  variant="btn btn-primary btn-block mt-2">Accedi</Button>} 
                        </Form>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </Container>
      </section>
        </>
    )
}

export default connect(mapStateToProps)(SignIn)